export class ContractGridViewItem {
    id?: string;
    name?: string;
    constructor(contractGridViewItem?: ContractGridViewItem) {
        this.id = contractGridViewItem?.id;
        this.name = contractGridViewItem?.name;       
    }

}
